import React, { useState, useEffect, useRef } from 'react';
import { Input } from 'semantic-ui-react';
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const SearchBar = ({
    setFilter,
    
}) => {
    const { t } = useTranslation();        
    const [filterInput, setFilterInput] = useState("");
    const filterChangeTimeout = useRef(null);

    const handleFilterChange = e => {
        const value = e.target.value || undefined;
        setFilterInput(value)
    };

    useEffect(() => {
        if (filterChangeTimeout.current) {
            clearTimeout(filterChangeTimeout.current);
        }

        filterChangeTimeout.current = setTimeout(() => {
            setFilter(filterInput || '');
        }, 300);

        return () => clearTimeout(filterChangeTimeout.current);
    }, [filterInput, setFilter]);

    return (
        <Input
            icon="search"
            value={filterInput}
            onChange={handleFilterChange}
            placeholder={t("ordersTable.search")}
            size="small"
            />
    )
};

SearchBar.propTypes = {
    setFilter: PropTypes.func,
    
};

export default SearchBar;